<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
        </el-breadcrumb>
        <div style="width:100%;height:40px;margin-bottom:10px;">
            <div class="top_buttons" style="float:left;">
                <el-button icon="el-icon-plus" type="primary" @click="Add_task">创建任务</el-button>
            </div>
            <div class="search" style="float:right;">
                <el-form :inline="true" :model="formInline" @submit.native.prevent>
                <el-form-item>
                <el-input
                placeholder="请输入搜索信息"
                v-model="formInline.search_info"
                @keyup.native.enter="search"
                clearable>
                </el-input>
                </el-form-item>
                <el-form-item>
                <el-button icon="el-icon-search" type="primary" @click="search">搜索</el-button>
                </el-form-item>
                </el-form>
            </div>
        </div>
    <el-table
    :data="task_list"
    style="width: 100%">
        <!-- <el-table-column prop="id" label="序号" min-width="5%"></el-table-column> -->
        <el-table-column type="index"></el-table-column>
        <el-table-column prop="task_name" label="任务名称" min-width="25%">
            <template slot-scope="scope">
                <span style="font-weight:bold;">{{ scope.row.task_name }}</span>
                <span v-if="scope.row.mana_survey==1" style="margin-left:5px;font-size:12px;color:#67C23A;font-weight:bold;border:1px solid #67C23A;border-radius:3px;">调</span>
                <span v-if="scope.row.import_task==1" style="margin-left:5px;font-size:12px;color:#409EFF;font-weight:bold;border:1px solid #409EFF;border-radius:3px;">导</span>
            </template>
        </el-table-column>
        <el-table-column prop="ques_name" label="评估类型" min-width="12%"></el-table-column>
        <el-table-column prop="company" label="参与公司" min-width="8%"></el-table-column>
        <el-table-column prop="effective_date" label="开始日期" min-width="9%"></el-table-column>
        <el-table-column prop="expiration_date" label="结束日期" min-width="9%"></el-table-column>
        <el-table-column prop="valid_status" label="任务状态" min-width="9%">
            <template slot-scope="scope">
                <div v-if="scope.row.valid_status=='未开始'" class="notStart_status">{{ scope.row.valid_status }}</div>
                <div v-if="scope.row.valid_status=='进行中'" class="inProgress_status">{{ scope.row.valid_status }}</div>
                <div v-if="scope.row.valid_status=='已完成'" class="finished_status">{{ scope.row.valid_status }}</div>
                <div v-if="scope.row.valid_status=='已失效'" class="invalid_status">{{ scope.row.valid_status }}</div>
            </template>
        </el-table-column>
        <el-table-column prop="operations" label="操作" min-width="20%">
            <template slot-scope="scope">
                <el-button
                size="mini"
                @click="handleEdit(scope.row)">编辑</el-button>
                <el-button class="delete_button"
                size="mini"
                type="danger"
                @click="handleDelete(scope.row)">删除</el-button>
                <el-button class="delete_button"
                size="mini"
                type="warning"
                @click="handleManage(scope.row.tid)">管理</el-button>
                <!-- <el-button class="delete_button"
                size="mini"
                type="primary"
                @click="export_progress(scope.row.tid)">导出进展</el-button>
                <el-button class="delete_button"
                size="mini"
                type="success"
                @click="export_results(scope.row.tid)">导出结果</el-button> -->
            </template>
        </el-table-column>
    </el-table>
    <div style="margin-top:10px;" v-if="task_list.length > 0">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageinfo.count"
            :page-sizes="pageinfo.page_sizes"
            :page-size="pageinfo.page_size"
            layout="total, sizes, prev, pager, next"
            :total="pageinfo.count">
        </el-pagination>
    </div>
    <el-dialog :title="dialog_title" 
    :visible.sync="dialogFormVisible" 
    width="560px" 
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    class="assessee_dialog">
        <el-form :model="form" class="dialog_form">
            <el-form-item label="任务名称" :label-width="formLabelWidth">
                <el-input v-model="form.task_name" autocomplete="off" placeholder="任务名称，请保持唯一"></el-input>
            </el-form-item>
            <el-form-item label="参与公司" :label-width="formLabelWidth">
                <el-input v-model="form.company" autocomplete="off" placeholder="参与公司名称"></el-input>
            </el-form-item>
            <el-form-item label="开始日期" :label-width="formLabelWidth">
                <el-date-picker 
                v-model="form.effective_date" 
                type="date" 
                placeholder="请选择日期" 
                format="yyyy 年 MM 月 dd 日" 
                value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item label="结束日期" :label-width="formLabelWidth">
                <el-date-picker v-model="form.expiration_date" 
                type="date" 
                placeholder="请选择日期" 
                format="yyyy 年 MM 月 dd 日" 
                value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogCancel">取 消</el-button>
            <el-button type="primary" @click="dialogSubmit">确 定</el-button>
        </div>
    </el-dialog> 
    </div>   
</template>

<script>
import postdata from "@/api/postData.js";
import getdata from "@/api/getData.js";
export default {
    beforeCreate() {
        getdata.getList("checklogin")
              .then(resp => {
                // 增加处理，非管理员用户不能登录任务管理页面
                if(resp.data.usertype != 'admin'){
                    this.$router.push({
                        name: 'notFound',
                    });
                }
              })
              .catch(() => {
                if(localStorage.getItem("token") != null){
                    this.$message({
                        message: '会话超时，请重新登录！',
                        type: 'warning',
                    })
                }
                this.$router.push({
                    path: '/JKlogin',
                });
              })
    },
    created() {
        this.getTaskInfo();
    },
    data() {
        return {
            pageinfo: {
                count: 0,
                current: 1,
                page_size: 10,
                page_sizes: [1, 10, 20, 50, 100],
            },
            formInline: {
                search_info: '',
                search_result: [],
            },
            task_list: [],
            dialogFormVisible: false,
            disable_flag: false,
            formLabelWidth: '80px',
            // 这里的结构需要先定义出来，否则会导致选择下拉列表的时候，选择的信息不会立马显示出来
            form: {
                tid: -1,
                task_name: '',
                company: '',
                effective_date: '',
                expiration_date: '',
                ques_name: '组织健康度诊断',
                jk_ques: [],
            },
            dialog_title: '',
        }
    },
    methods: {
        dialogCancel() {
            // 增加处理，重新读取从后端传递过来的原始记录进行覆盖----从后台读取数据时，直接取消即可
            this.dialogFormVisible = false;  
        },
        dialogSubmit() {
            // 增加处理，将修改后的form提交后台直接更新至数据库，若成功则重新获取修改后的数据并渲染到前端
            postdata.postList("addJKTask", JSON.stringify(this.form))
              .then(resp => {
                if(resp.data.code == 200){
                    if(resp.data.message=='创建成功！' || resp.data.message=='更新成功！'){
                        this.$message({
                            message: resp.data.message,
                            type: 'success',
                        })
                        this.dialogFormVisible = false;
                        // 加载最新的任务列表
                        this.getTaskInfo();
                    }else{
                        this.$message({
                            message: resp.data.message,
                            type: 'error',
                            duration: 6000,
                            // showClose: true,
                        })
                    }
                }
              })
              .catch(err => {
                console.log(err);
              })             
        },
        handleEdit(row) {
            this.dialog_title = '编辑任务',
            this.disable_flag = true;
            this.getTaskInfo(row.tid);
            // this.getCompanyList(row.company);
            this.dialogFormVisible = true;
        },
        handleDelete(row) {
            // 这里的rows是传的整个表格的数据，网上说的用scope.row不行
            // 还是换成从后台删除，然后传最新的数据过来渲染
            // rows.splice(index, 1); 
            this.$confirm("确认删除这条记录么？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                // console.log(id);    //最终这里换成后台接口删除记录
                // if(row.valid_status=="进行中"){
                //     this.$message({
                //         message: "进行中的任务无法删除！",
                //         type: "error",
                //         duration: 6000,
                //         // showClose: true,
                //     })
                // }else{
                let params;
                params = {
                    task_id: row.tid,
                }
                getdata.getListP("deleteJKTask", params)
                .then(resp => {
                    if(resp.data.code == 200){
                        this.$message({
                            message: "已删除！",
                            type: "success",
                        })
                        this.getTaskInfo();
                    }
                })
                .catch(err => {
                    console.log(err);
                });
                // }
            }).catch(() => {
                
            })
        },
        handleSizeChange: function(size) {
            // 这里的size还有下面的currentPage都是系统自动识别到的，直接使用即可
            this.pageinfo.page_size = size;
            this.pageinfo.current = 1;
            // console.log('page_size: ' + this.pageinfo.page_size);
            if(this.formInline.search_info==''){
                this.getTaskInfo();
            }else{
                this.getTaskInfo(-1, this.formInline.search_info);
            }
            // console.log(this.pageinfo.page_size)
            // 如果后台获取的数据较大，可考虑根据分页信息从后台获取对应的信息（不全量获取）
        },
        handleCurrentChange: function(currentPage) {
            this.pageinfo.current = currentPage;
            // console.log('current: ' + this.pageinfo.current);
            if(this.formInline.search_info==''){
                this.getTaskInfo();
            }else{
                this.getTaskInfo(-1, this.formInline.search_info);
            }
            // console.log(this.pageinfo.current)
            // 如果后台获取的数据较大，可考虑根据分页信息从后台获取对应的信息（不全量获取）
        },
        // 不同的评估类型跳转到不同的页面
        handleManage(id) {
            this.$router.push({
                name: 'JKTaskMgmt',
                query: {
                taskid: id,
                }
            })          
        },
        Add_task() {
            this.dialog_title = '新增任务';
            this.disable_flag = false;
            // this.form = {};
            // 因为form有预定义的结构了，所以这里需要重新改造对form的初始化
            this.init_form();
            this.dialogFormVisible = true;
            // this.getCompanyList();
        },
        init_form() {
            this.form.tid = -1;
            this.form.task_name = '';
            this.form.company = '';
            this.form.effective_date = '';
            this.form.expiration_date = '';
            this.form.ques_name = '组织健康度诊断';
        },
        getTaskInfo(id, query_info) {
            id = id||-1;      // 设置参数默认值为-1
            query_info = query_info||'';
            let params;
            params = {
                start: (this.pageinfo.current - 1) * this.pageinfo.page_size,
                end: (this.pageinfo.current) * this.pageinfo.page_size,
                query_info: query_info,
                task_id: id,
                // ques_name: this.form.ques_name,
            }
            getdata.getListP("getJKTasks", params)
                .then(resp => {
                    if(resp.data.code == 200){
                        if(id==-1){
                            this.task_list = resp.data.data;
                            this.pageinfo.count = resp.data.count;
                        }else{
                            // 因为form是字典，所以要使用data[0]赋值
                            this.form = resp.data.data[0];
                        }  
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },
        search() {
            // console.log('this.pageinfo.current: ' + this.pageinfo.current);
            this.getTaskInfo(-1, this.formInline.search_info);
        },
        export_progress(id) {
            let params;
            params = {
                task_id: id,
            }
            postdata.downloadFilesP("exportProgressByUsers", JSON.stringify(this.progress_template_file), params)
              .then(resp => {
                // 将流文件通过浏览器下载，这里使用整个后台返回的response，供download函数提取data、headers等信息
                this.download(resp);
              })
              .catch(err => {
                console.log(err);
              })
        },
        export_results(id) {
            let params;
            params = {
                task_id: id,
            }
            postdata.downloadFilesP("exportResultsByUsers", JSON.stringify(this.results_template_file), params)
            .then(resp => {
                // 将流文件通过浏览器下载，这里使用整个后台返回的response，供download函数提取data、headers等信息
                this.download(resp);
            })
            .catch(err => {
                console.log(err);
            })
        },
        download (res) {
            let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });//type是文件类，详情可以参阅blob文件类型
            // 创建新的URL并指向File对象或者Blob对象的地址
            const blobURL = window.URL.createObjectURL(blob)
            // 创建a标签，用于跳转至下载链接
            const tempLink = document.createElement('a')
            tempLink.style.display = 'none'
            tempLink.href = blobURL
            tempLink.setAttribute('download', decodeURI(res.headers['content-disposition'].split(';')[1].split('=')[1]))
            // 兼容：某些浏览器不支持HTML5的download属性
            if (typeof tempLink.download === 'undefined') {
                tempLink.setAttribute('target', '_blank')
            }
            // 挂载a标签
            document.body.appendChild(tempLink)
            tempLink.click()
            document.body.removeChild(tempLink)
            // 释放blob URL地址
            window.URL.revokeObjectURL(blobURL)
        },
    }
}
</script>

<style scoped>
/* .el-table {
    font-size: 18px;
} */
.top_buttons > .el-button {
    font-size: 16px;
    /* font-weight: bold; */
}
.search /deep/ .el-input {
    font-size: 16px;
}
.search /deep/ .el-button {
    font-size: 16px;
}
.search /deep/ .el-input__inner {
    height: 42.67px;
    line-height: 42.67px;
}
/* .el-button {
    font-size: 18px;
} */
.el-table /deep/ th.el-table__cell {
    background-color: #f5f7fa;
}
/* .search /deep/ .el-input {
    font-size: 18px;
}
.search /deep/ .el-input__inner {
    height: 45px;
    line-height: 45px;
}
::v-deep .el-pagination span, ::v-deep .el-pagination button, ::v-deep .el-pager li {
    font-size: 18px;
    line-height: 45px;
    height:45px;
}
::v-deep .el-pagination__sizes .el-input .el-input__inner, ::v-deep .el-select .el-input .el-select__caret {
    font-size: 18px;
} */
.assessee_dialog /deep/ .el-dialog__header {
    text-align: left;
}
.assessee_dialog /deep/ .el-dialog__body {
    padding: 20px 20px 0px 20px;
}
.dialog_form /deep/ .el-input {
    /* width: 223.67px; */
    width: 400px;
}
/* ::v-deep .el-input--mini .el-input__icon {
    line-height: 45px;
} */
.delete_button {
    margin-left: 10px;
}
::v-deep .el-form-item {
    margin-bottom: 0;
}
::v-deep .el-table__header {
    font-size: 16px;
}
.dialog_form /deep/ .el-form-item {
    margin-bottom: 14px;
}
.dialog_form /deep/ .el-textarea__inner {
    font-family: Avenir,Helvetica,Arial,sans-serif;
}
::v-deep .el-alert__title {
    font-size: 16px;
}
.dialog_form /deep/ .el-alert__title {
    font-size: 14px;
}
::v-deep .el-dialog__footer {
    text-align: center;
}
.notStart_status {
    font-size: 12px;
    background: #E6A23C;
    display: inline-block;
    white-space: nowrap;
    padding: 7px 15px;
    border-radius: 3px;
    line-height: 1;
    color: white;
}
.finished_status {
    font-size: 12px;
    background: #67C23A;
    display: inline-block;
    white-space: nowrap;
    padding: 7px 15px;
    border-radius: 3px;
    line-height: 1;
    color: white;
}
.inProgress_status {
    font-size: 12px;
    background: #409EFF;
    display: inline-block;
    white-space: nowrap;
    padding: 7px 15px;
    border-radius: 3px;
    line-height: 1;
    color: white;
}
.invalid_status {
    font-size: 12px;
    background: #909399;
    display: inline-block;
    white-space: nowrap;
    padding: 7px 15px;
    border-radius: 3px;
    line-height: 1;
    color: white;
}
.el-breadcrumb {
    font-size: 20px;
    border-left: solid 6px #606266;
    padding-left: 15px;
    margin-bottom: 50px;
}
.mana_survey /deep/ .el-form-item__content {
    text-align: left;
    padding-left: 20px;
}
</style>